// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-parameters-components-header-index-module__header-fNLWwk {
  align-items: center;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-header-index-module__header-fNLWwk .\\------packages-common-biz-components-src-parameters-components-header-index-module__name-lkeX91 {
  flex: 1;
}

.\\------packages-common-biz-components-src-parameters-components-header-index-module__header-fNLWwk .\\------packages-common-biz-components-src-parameters-components-header-index-module__type-PVzaBb {
  flex-grow: 0;
  flex-shrink: 0;
  width: 155px;
  margin-left: 8px;
}

.\\------packages-common-biz-components-src-parameters-components-header-index-module__header-fNLWwk .\\------packages-common-biz-components-src-parameters-components-header-index-module__description-wOrxF3 {
  width: 312px;
  margin-left: 8px;
}

.\\------packages-common-biz-components-src-parameters-components-header-index-module__header-fNLWwk.\\------packages-common-biz-components-src-parameters-components-header-index-module__withDescription-wSH9rA .\\------packages-common-biz-components-src-parameters-components-header-index-module__name-lkeX91 {
  flex: none;
  width: 181px;
}

.\\------packages-common-biz-components-src-parameters-components-header-index-module__text-hRzSet {
  color: var(--light-usage-text-color-text-3, rgba(28, 31, 35, .35));
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `------packages-common-biz-components-src-parameters-components-header-index-module__header-fNLWwk`,
	"name": `------packages-common-biz-components-src-parameters-components-header-index-module__name-lkeX91`,
	"type": `------packages-common-biz-components-src-parameters-components-header-index-module__type-PVzaBb`,
	"description": `------packages-common-biz-components-src-parameters-components-header-index-module__description-wOrxF3`,
	"withDescription": `------packages-common-biz-components-src-parameters-components-header-index-module__withDescription-wSH9rA`,
	"text": `------packages-common-biz-components-src-parameters-components-header-index-module__text-hRzSet`
};
export default ___CSS_LOADER_EXPORT___;
